module.exports = __webpack_public_path__ + "img/tarjeta_promocion_aspirador.ebe9473c.jpg";